import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

interface DialogComponentInput {
  open: boolean;
  onClose?: any;
  title: string;
  contentText: string;
  onConfirm: any;
  onCancel: any;
  confirmText: string;
  cancelText: string;
}

function DialogComponent(props: DialogComponentInput) {
  const { open, onClose, title, contentText, onConfirm, onCancel, confirmText, cancelText } = props;
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{contentText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" autoFocus onClick={onConfirm}>
          {confirmText}
        </Button>
        <Button onClick={onCancel} color="primary">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogComponent;
